import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import withLoader from "./../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar, TextField } from "@material-ui/core";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ConfigLivraisonService from "../../services/PosService/ConfigLivraisonService";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddConfigColis = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [configLivraison, setConfigLivraison] = useState({});
  //alert
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setConfigLivraison({ ...configLivraison, [name]: value });
  };
  function isEmpty(value) {
    return value == null || value === "" || value === undefined;
  }
  const sendConfigData = (e) => {
    const model = {
      idUser: getCurrentUserId(),
      login: configLivraison?.login,
      password: configLivraison?.password,
    };
    if (isEmpty(model?.login) && isEmpty(model?.password)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez remplir les champs");
      return;
    } else if (isEmpty(model?.login)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez remplir le champs login");
      return;
    } else if (isEmpty(model?.password)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez ajouter votre password");
      return;
    }
    //save colis config
    startLoading();
    ConfigLivraisonService.saveConfigLivraison(model)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.success);
          setConfigLivraison({});
        } else if (response.data.error) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.error);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div className="card-header">
              <h5 className="card-title">Ajouter Configuration de Livraison</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Login</label>
                    <input
                      onChange={handleChange}
                      type="text"
                      id="inputName"
                      className="form-control"
                      name="login"
                      placeholder="saisir votre login"
                      value={configLivraison?.login || ""}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Password</label>
                    <input
                      onChange={handleChange}
                      type="password"
                      id="inputName"
                      className="form-control"
                      name="password"
                      placeholder="saisir votre password"
                      value={configLivraison?.password || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="col-sm-12  text-right">
                <button className="btn btn-dark" onClick={sendConfigData}>
                  Confirmer configuration
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddConfigColis);
